export default __webpack_public_path__ + "static/media/content-loader-vs-loading.43be49f8.gif";